// extracted by mini-css-extract-plugin
export default {"votes":"votes_votes__uPtf6"};